import IconUtils from '../utils/icon-utils';

/*
  Sort/Default: https://www.figma.com/file/y90piHmWzPWasY4ZkcdXVs/Design-Library?node-id=288%3A16
  Sort/Asc:     https://www.figma.com/file/y90piHmWzPWasY4ZkcdXVs/Design-Library?node-id=1515%3A4335
  Sort/Desc:    https://www.figma.com/file/y90piHmWzPWasY4ZkcdXVs/Design-Library?node-id=1515%3A4338
 */
const Sort = ({ height = 16, width = 16, order = 'default', color, className }) => {
  const { stroke } = IconUtils.getColorOrDefault(color);

  if (order === 'asc') {
    return (
      <svg
        className={className}
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 10L8 13L11 10" stroke={stroke} />
        <path d="M5 6L8 3L11 6" stroke={stroke} strokeOpacity="0.25" />
      </svg>
    );
  }

  if (order === 'desc') {
    return (
      <svg
        className={className}
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 10L8 13L11 10" stroke={stroke} strokeOpacity="0.25" />
        <path d="M5 6L8 3L11 6" stroke={stroke} />
      </svg>
    );
  }

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 6L8 3L11 6M5 10L8 13L11 10" stroke={stroke} />
    </svg>
  );
};

export default Sort;
